<template>
  <svg
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  >
    <metadata>
      <rdf:RDF>
        <cc:Work rdf:about>
          <dc:format>image/svg+xml</dc:format>
          <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"></dc:type>
          <dc:title></dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <path
      d="m12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.31 7.526c-0.099-0.807 0.528-1.526 1.348-1.526 0.771 0 1.377 0.676 1.28 1.451l-0.757 6.053c-0.035 0.283-0.276 0.496-0.561 0.496s-0.526-0.213-0.562-0.496zm1.31 10.724c-0.69 0-1.25-0.56-1.25-1.25s0.56-1.25 1.25-1.25 1.25 0.56 1.25 1.25-0.56 1.25-1.25 1.25z"
      :fill="color"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "Warning",
  props: ["color"]
};
</script>

<style>
</style>
